const state = {
  userSetting: {},
  userAvatar: {},
  userLicense: {}
}

const getters = {
  userSetting: state => state.userSetting,
  userAvatar: state => state.userAvatar,
  userLicense: state => state.userLicense
}

const types = {
  setUserSetting: 'global/userSetting',
  setUserAvatar: 'global/setUserAvatar',
  setUserLicense: 'global/setUserLicense'
}

const mutations = {
  [types.setUserSetting] (state, obj) {
    state.userSetting = obj
  },
  [types.setUserAvatar] (state, obj) {
    state.userAvatar = obj
  },
  [types.setUserLicense] (state, obj) {
    state.userLicense = obj
  }
}

const actions = {
  setUserSettingAction ({commit}, obj) {
    commit(types.setUserSetting, obj)
  },
  setUserLicenseAction ({commit}, obj) {
    commit(types.setUserLicense, obj)
  }
}

export default {
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/global.js